import React, { FC } from 'react'

import { ReactComponent as SomniumBlockchain } from 'assets/images/somniumBlockchain/somniumBlockchain.svg'
import Cube from 'assets/images/somniumBlockchain/cube.png'
import SDKItems from 'assets/images/somniumBlockchain/SDKItems.png'
import BlockchainWorlds from 'assets/images/somniumBlockchain/blockchainWorlds.png'
import Parcel from 'assets/images/somniumBlockchain/parcel.png'
import Avatars from 'assets/images/somniumBlockchain/avatars.png'
import { ReactComponent as EmblemColor } from 'assets/images/somniumBlockchain/emblemColor.svg'

import styles from './styles.module.scss'

interface IProps {
}

export const SomniumAnimation: FC<IProps> = props => {

  return (
    <div className={styles.animationContainer}>
      <SomniumBlockchain/>
      <img src={Cube} className={styles.cube} alt="cube"/>
      <img src={SDKItems} className={styles.SDKItems} alt="SDKItems"/>
      <img src={BlockchainWorlds} className={styles.blockchainWorlds} alt="blockchainWorlds"/>
      <img src={Parcel} className={styles.parcel} alt="parcel"/>
      <img src={Avatars} className={styles.avatars} alt="avatars"/>
      <EmblemColor className={styles.somniumIcon}/>
    </div>
  )
}
